import React from 'react'
import { TfiMenuAlt } from 'react-icons/tfi'
import { BiRightArrowAlt } from 'react-icons/bi'
import { HiOutlinePlusSm } from 'react-icons/hi'

const ProductsPriceTable = () => {
    return (
        <div>
            <div className='h-[564px] flex items-center justify-center'>
                <div className="p-[64px]">
                    <div className='p-[12px] w-max rounded-[8px] bg-[#f6f8fa]'>
                        <TfiMenuAlt className="fill-gray-500 text-[25px]" />
                    </div>
                    <div className="mt-6">
                        <span className="text-[20px] font-bold text-[#1a1b25]">Create a pricing table</span>
                    </div>
                    <p className="text-sm text-[#687385] max-w-[389px] flex-wrap mt-1">Create a branded, responsive pricing table to embed on your website.
                        <span className="text-[#625afa] mt-1 flex items-center font-medium gap-1 text-sm">
                            Learn more
                            <BiRightArrowAlt className='text-[20px] translate-y-[2px]' />
                        </span>
                    </p>
                    <button className="flex gap-1 mt-5 text-white font-semibold h-[30px] bg-[#635bff] rounded-[6px] text-[14px] items-center p-[4px_8px]"><HiOutlinePlusSm className="text-[22px]" />Create a test coupon</button>
                </div>
            </div>
        </div>
    )
}

export default ProductsPriceTable